'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var raf = {exports: {}};

exports.raf = raf;
